import { HugeiconsIcon } from "@hugeicons/react";
import {
  ComputerTerminal01Icon,
} from "@hugeicons/core-free-icons";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export default function SomethingWentWrong() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center p-4 overflow-hidden relative selection:bg-destructive/30">
      {/* Background Grid Pattern */}
      <div className="absolute inset-0 w-full h-full bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-size-[24px_24px]"></div>

      {/* Ambient Glow */}
      <div className="absolute left-0 top-0 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-destructive/10 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute right-0 bottom-0 translate-x-1/2 translate-y-1/2 w-96 h-96 bg-slate-500/10 rounded-full blur-3xl pointer-events-none"></div>

      <Card className="w-full max-w-md backdrop-blur-xl shadow-2xl relative z-10 overflow-hidden group">
        {/* Top Accent Line */}
        <div className="absolute top-0 left-0 w-full h-1 bg-linear-to-r from-red-600 via-orange-500 to-red-600 animate-gradient-x"></div>

        <CardHeader className="space-y-1">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 text-destructive">
              <HugeiconsIcon
                icon={ComputerTerminal01Icon}
                className="h-4 w-4"
              />
              <span className="text-xs font-mono tracking-widest uppercase">
                System_Error
              </span>
            </div>
            <div className="h-2 w-2 rounded-full bg-destructive animate-pulse shadow-[0_0_10px_rgba(239,68,68,0.5)]"></div>
          </div>

          <div className="space-y-2 pt-1">
            <CardTitle className="text-xl font-medium">
              ERROR OCCURRED
            </CardTitle>
          </div>
        </CardHeader>

        <CardContent>
          <div className=" rounded-lg p-2 border bg-black font-mono text-sm text-slate-400 space-y-2">
            <div className="flex gap-2">
              <span className="text-destructive">{">"}</span>
              <span>
                ERROR_CODE:{" "}
                <span className="text-slate-200">NULL_POINTER_EXCEPTION</span>
              </span>
            </div>
            <div className="flex gap-2">
              <span className="text-destructive">{">"}</span>
              <span>
                LOCATION:{" "}
                <span className="text-slate-200">/unknown_sector</span>
              </span>
            </div>
            <div className="flex gap-2">
              <span className="text-destructive animate-pulse">_</span>
            </div>
          </div>
          <p className="text-slate-400 text-sm mt-2">
            The requested resource is unavailable or has been moved to a
            different sector.
          </p>
        </CardContent>

        <CardFooter>
          <Button variant="outline" asChild>
            <a href="/home">Return to Dashboard</a>
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
